import { any, bool, object } from 'prop-types';
import React from 'react';
import { components } from 'react-select';
import styled from 'styled-components';

import { CheckboxEmptyIcon, CheckboxFilledIcon, NewCheckboxEmptyIcon } from 'components/Icons';

const CheckMarkContainerStyled = styled.div`
    align-items: center;
    display: flex;
    width: 20px;
    justify-content: space-between;
`;

const OptionStyled = styled.div`
    display: flex;
    justify-content: flex-start;
    width: 100%;
`;

const MultiSelectOption = ({ children, ...props }) => {
    const {
        isDisabled,
        isSelected,
        selectProps: { updateIcon },
    } = props;
    let checkboxIcon;
    if (!updateIcon) {
        checkboxIcon = isSelected ? <CheckboxFilledIcon /> : <CheckboxEmptyIcon />;
    } else if (updateIcon) {
        checkboxIcon = isDisabled ? (
            <NewCheckboxEmptyIcon />
        ) : isSelected ? (
            <CheckboxFilledIcon height="24" width="24" />
        ) : (
            <CheckboxEmptyIcon height="24" width="24" />
        );
    }

    return (
        <components.Option {...props}>
            <OptionStyled>
                <CheckMarkContainerStyled>{checkboxIcon}</CheckMarkContainerStyled>
                {children}
            </OptionStyled>
        </components.Option>
    );
};

MultiSelectOption.propTypes = {
    children: any.isRequired,
    isSelected: bool.isRequired,
    isDisabled: bool,
    selectProps: object,
};

MultiSelectOption.defaultProps = {
    isDisabled: false,
    selectProps: {},
};

export default MultiSelectOption;
